import { useQuery } from "react-query";
import { api } from "../api";

export function useApiChurchs() {
  const { data: dataChurch, isLoading: isLoadingDataChurch, error } = useQuery(
    "churchs",
    async () => {
      console.log("Fazendo requisição para /church");
      const response = await api.get("/church");
      console.log("Resposta completa da API:", response);
      console.log("Dados da resposta:", response.data);
      console.log("Status da resposta:", response.data.status);
      console.log("Tipo do status:", typeof response.data.status);
      
      // Ajustar para a estrutura da API Laravel
      if (response.data.status === "success") {
        return response.data.data;
      } else {
        console.error("API retornou status diferente de 'success':", response.data.status);
        console.error("Estrutura completa da resposta:", response.data);
        throw new Error(`API retornou status: ${response.data.status}`);
      }
    },
    {
      onError: (error) => {
        console.error("Erro ao carregar congregações:", error);
        console.error("Detalhes do erro:", {
          message: error.message,
          status: error.response?.status,
          data: error.response?.data,
        });
      },
      retry: 1,
      refetchOnWindowFocus: false,
    }
  );

  return { dataChurch, isLoadingDataChurch, error };
}
